var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"regular-line-button-blue70",on:{"click":_vm.handleClick}},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t('menu.contact_us'))+"\n    ")])]),_c('MailModal'),_c('ContactModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }